import { render, staticRenderFns } from "./folder_name.vue?vue&type=template&id=6f3dc0a4"
import script from "./folder_name.vue?vue&type=script&lang=js"
export * from "./folder_name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports